import commonMapping from "@/mapping/common";
const servtype_list = [
  { value: "TCP/UDP", config: "TCP_UDP", label: "block_ser_setup_tcp_udp" },
  { value: "TCP", label: "block_ser_setup_tcp", config: "TCP" },
  { value: "UDP", label: "block_ser_setup_udp", config: "UDP" },
];
const src_ip_type_list = [
  { value: "Any", label: "any", config: "0" },
  { value: "Single address", label: "single_addr", config: "1" },
];
const pt_type_list = [
  { value: "TCP", label: "block_ser_setup_tcp", config: "TCP" },
  { value: "UDP", label: "block_ser_setup_udp", config: "UDP" },
];
const in_port_type_list = [
  { value: "TCP/UDP", label: "block_ser_setup_tcp_udp", config: "TCP_UDP" },
  { value: "TCP", label: "block_ser_setup_tcp", config: "TCP" },
  { value: "UDP", label: "block_ser_setup_udp", config: "UDP" },
];

const serv_type_list = [
  { value: "forward", config: "forward", label: "port_forward", id: "serv_pf" },
  { value: "trigger", config: "trigger", label: "port_trigger", id: "serv_pt" },
];
const svs_gm_list = [
  /* jshint ignore:start */
  //firewall.port_forwarding.list:[name] [proto] [ext-port-range] [int-port-range] [ipaddr] [same-range]
  //name=config, proto=serv_type,  ext-port-range=exter_port, int-port-range=internal_port, same-range=same_range.
  /* jshint ignore:end */
  {
    value: "FTP",
    label: "block_ser_setup_ftp",
    config: "FTP",
    servtype: "TCP",
    exter_port: "20-21",
    internal_port: "20-21",
    same_range: "1",
  },
  {
    value: "HTTP",
    label: "block_ser_setup_http",
    config: "HTTP",
    servtype: "TCP",
    exter_port: "80",
    internal_port: "80",
    same_range: "1",
  },
  {
    value: "ICUII",
    label: "block_ser_setup_icu",
    config: "ICUII",
    servtype: "TCP",
    exter_port: "23566",
    internal_port: "23566",
    same_range: "1",
  },
  {
    value: "IP_Phone",
    label: "block_ser_setup_ipphone",
    config: "IP_Phone",
    servtype: "TCP",
    exter_port: "6670",
    internal_port: "6670",
    same_range: "1",
  },
  {
    value: "NetMeeting",
    label: "block_ser_setup_netmeet",
    config: "NetMeeting",
    servtype: "TCP",
    exter_port: "1720",
    internal_port: "1720",
    same_range: "1",
  },
  {
    value: "News",
    label: "block_ser_setup_news",
    config: "News",
    servtype: "TCP",
    exter_port: "119",
    internal_port: "119",
    same_range: "1",
  },
  {
    value: "PPTP",
    label: "block_ser_setup_pptp",
    config: "PPTP",
    servtype: "TCP",
    exter_port: "1723",
    internal_port: "1723",
    same_range: "1",
  },
  {
    value: "QuakeII/III",
    label: "block_ser_setup_quake",
    config: "QuakeII/III",
    servtype: "TCP_UDP",
    exter_port: "27960",
    internal_port: "27960",
    same_range: "1",
  },
  {
    value: "Real-Audio",
    label: "block_ser_setup_real",
    config: "Real-Audio",
    servtype: "TCP_UDP",
    exter_port: "6970-7170",
    internal_port: "6970-7170",
    same_range: "1",
  },
  {
    value: "Telnet",
    label: "block_ser_setup_telnet",
    config: "Telnet",
    servtype: "TCP",
    exter_port: "23",
    internal_port: "23",
    same_range: "1",
  },
];

export const pfPt = {
  serv_type: serv_type_list,
  svs_gm: svs_gm_list,
  triggering_disable: commonMapping.intToBoolean,
  /**forwarding table */
  servtype: servtype_list,
  /**forwarding edit page */
  same_range: commonMapping.intToBoolean,
  /**triggering table */
  fwpt_enable: commonMapping.intToBoolean,
  src_ip_type: src_ip_type_list,
  pt_type: pt_type_list,
  in_port_type: in_port_type_list,
};

export default pfPt;
